/**
 * OfflineBanner — shows at the top when offline or when there are
 * pending queued mutations waiting to sync.
 */
import React from 'react';
import { WifiOff, RefreshCw, Loader2 } from 'lucide-react';
import { useOfflineSync } from '../../hooks/useOfflineSync';

const OfflineBanner = () => {
  const { isOnline, pendingCount, syncing, replayQueue } = useOfflineSync();

  const hidden = isOnline && pendingCount === 0;

  return (
    <div
      className={`fixed top-0 left-0 right-0 z-[100] flex items-center justify-center gap-2 px-4 py-2 text-xs font-medium text-white transition-[transform,opacity]
        ${isOnline ? 'bg-amber-600' : 'bg-gray-800'}`}
      style={{
        display: hidden ? 'none' : 'flex',
        paddingTop: `calc(0.5rem + env(safe-area-inset-top, 0))`,
      }}
      data-testid="offline-banner"
    >
      {!isOnline ? (
        <>
          <WifiOff className="w-3.5 h-3.5 flex-shrink-0" />
          <span>You're offline — changes will sync when reconnected</span>
        </>
      ) : (
        <>
          {syncing
            ? <Loader2 className="w-3.5 h-3.5 animate-spin flex-shrink-0" />
            : <RefreshCw className="w-3.5 h-3.5 flex-shrink-0" />}
          <span>
            {syncing
              ? 'Syncing offline changes…'
              : `${pendingCount} change${pendingCount !== 1 ? 's' : ''} pending sync`}
          </span>
          {!syncing && (
            <button onClick={replayQueue} className="underline ml-1 hover:no-underline">
              Sync now
            </button>
          )}
        </>
      )}
    </div>
  );
};

export default OfflineBanner;
